import { Component, ViewChild, TemplateRef, Input } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'sd-bottom-sheet',
  templateUrl: './bottom-sheet.component.html'
})
export class BottomSheetComponent {
  @ViewChild('templateRef') templateRef: TemplateRef<OptionTemplateContext>;
  @Input() title: string;
  isOpened = false;
  constructor(
    private bottomSheet: MatBottomSheet,
    // public bottomSheetRef: MatBottomSheetRef<BottomSheetComponent>
  ) { }

  open = () => {
    this.isOpened = true;
    this.bottomSheet.open(this.templateRef);
  }

  close = () => {
    this.bottomSheet.dismiss();
  }
}

interface OptionTemplateContext {
  $implicit: any;
}
